var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.redirect.status)?_c('div',{staticClass:"modal__overlay"},[_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal__message"},[_vm._v(_vm._s(_vm.redirect.message))]),_c('v-btn',{attrs:{"block":"","color":"primary","to":_vm.redirect.url},on:{"click":_vm.clearRedirect}},[_vm._v("Продолжить")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }